import { render, staticRenderFns } from "./SimpleCard.vue?vue&type=template&id=45eb71c6&scoped=true&"
import script from "./SimpleCard.vue?vue&type=script&lang=js&"
export * from "./SimpleCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCard.vue?vue&type=style&index=0&id=45eb71c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb71c6",
  null
  
)

export default component.exports